// /trust/approve: where a device's QR to be added to the trusted devices
// points. On an iPhone or iPad with the app, the QR opens the app instead
// (Universal Links), so this page is seen only without it: it says how to go
// on. The code after `#` is the app's; the page neither reads nor sends it.
import { m } from "@trameria/cloud-i18n";
import { SignedOutPage } from "./signed-out-page";

export function TrustApprovePage() {
  return (
    <SignedOutPage title={m.web_trust_approve_title()}>
      <p className="text-[13px] leading-[1.7]">{m.web_trust_approve_phone()}</p>
      <p className="mt-3 text-[13px] leading-[1.7]">
        {m.web_trust_approve_pc()}
      </p>
    </SignedOutPage>
  );
}
